/**
 * Creates a list of a range of years between 'from' and 'to'
 * @param {number|string} from Number used as the start of the year's range
 * @param {number|string} to Number used as the end of the year's range. Default: new Date().getFullYear()
 * @returns {Array.<number>} List of years based on range (ascending order)
 */
export function composeRangeYears(from, to = new Date().getFullYear()) {
  const fromYear = Number(from);
  let toCounter = Number(to);

  if (Number.isNaN(fromYear)) {
    throw new Error(`Parameter 'from' should be a number or string with number`);
  } else if (Number.isNaN(toCounter)) {
    throw new Error(`Parameter 'to' should be a number or string with number`);
  }

  const years = [];
  while (toCounter >= fromYear) {
    years.push(toCounter);
    toCounter--;
  }
  return years;
}

/**
 * Removes or appends an url search param
 * @param {string|URL} url The url to use
 * @param {string} param The param to remove from the url search
 * @param {string} value The value to use when appending the param
 * @param {boolean} strict If true only toggle the param if the value is the same as the param value
 */
export function toggleURLParams(link, param, value = '', strict = false) {
  const url = new URL(link);
  const hasParam = url.searchParams.has(param);
  const paramValue = url.searchParams.get(param);
  const hasSameValues = value == paramValue;

  if (strict && hasParam && !hasSameValues) {
    return url;
  }

  if (hasParam) {
    url.searchParams.delete(param);
  } else {
    url.searchParams.set(param, value);
  }

  return url;
}
